import * as R from 'ramda';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import axios from 'axios';
import classNames from 'classnames';

import BrandCampaignSelect from 'js/publisher_leads/brand_campaign_select';
import LoadingSpinner from 'js/components/loading_spinner';

export default class FlightFinder extends Component {
    static propTypes = {
        campaignFuzzySearchUrl: PropTypes.string.isRequired,
        flightsApiUrl: PropTypes.string.isRequired,
        onSelect: PropTypes.func.isRequired,
        enums: PropTypes.shape({
            InviteFlightStatus: PropTypes.shape({
                PENDING: PropTypes.string.isRequired,
                SENT: PropTypes.string.isRequired
            }).isRequired
        }),
        currentlySelected: PropTypes.string
    };

    constructor() {
        super();

        this.state = {
            isFinding: false,
            selectedCampaign: null,
            transmitting: false,
            flights: null
        };
    }

    /**
     * @param {number} campaignId
     * @memberof FlightFinder
     */
    handleCampaignSelect = campaignId => {
        const {
            flightsApiUrl,
            enums: {InviteFlightStatus}
        } = this.props;
        this.setState({transmitting: true}, () => {
            axios
                .get(flightsApiUrl, {
                    params: {
                        campaign_id: campaignId,
                        status: InviteFlightStatus.SENT
                    }
                })
                .then(({data}) => this.setState({flights: data, transmitting: false}))
                .catch(() => {
                    this.setState({transmitting: false});
                });
        });
    };

    /**
     * @param {number} flightId
     * @memberof FlightFinder
     */
    setCurrentFlight = flightId => {
        const {onSelect} = this.props;
        onSelect(flightId);
    };

    toggleIsFinding = () => {
        if (this.state.isFinding) {
            this.setState({
                isFinding: false,
                flights: null
            });
        } else {
            this.setState({isFinding: true});
        }
    };

    displayTransmittingSpinner = () => {
        if (this.state.transmitting) {
            return <LoadingSpinner />;
        }
    };

    displayToggleInput = () => {
        const {isFinding} = this.state;
        const {currentlySelected} = this.props;

        const btnClass = classNames('btn', {
            'btn-primary': !isFinding,
            'btn-success': isFinding
        });

        return (
            <div className="input-group">
                <input
                    type="text"
                    className="form-control"
                    value={R.isNil(currentlySelected) ? '' : currentlySelected}
                    onChange={e => {
                        this.setCurrentFlight(e.target.value);
                    }}
                />
                <span className="input-group-btn">
                    <button className={btnClass} onClick={this.toggleIsFinding}>
                        Find A Flight
                    </button>
                </span>
            </div>
        );
    };

    displayFlights = () => {
        const {flights} = this.state;
        const {currentlySelected} = this.props;

        if (flights) {
            if (flights === []) {
                return 'There are no sent flights in this campaign';
            }

            const flightOptions = R.map(({id, pretty_name}) => (
                <option key={id} value={id}>
                    {pretty_name}
                </option>
            ))(flights);

            return (
                <div className="form-group">
                    <label htmlFor="flights" id="flights">
                        <select
                            className="form-control"
                            value={currentlySelected}
                            onChange={e => {
                                this.setCurrentFlight(e.target.value);
                            }}
                        >
                            <option>Select Flight</option>
                            {flightOptions}
                        </select>
                    </label>
                </div>
            );
        }
    };

    displayBrandCampaignSelect = () => {
        const {isFinding} = this.state;

        if (isFinding) {
            const {campaignFuzzySearchUrl} = this.props;
            const flightSelect = this.displayFlights();

            return (
                <div className="crm-filter-inner-panel">
                    <BrandCampaignSelect
                        showSubmitButton={false}
                        campaignFuzzySearchUrl={campaignFuzzySearchUrl}
                        handleCampaignSelect={this.handleCampaignSelect}
                    />

                    {flightSelect}
                </div>
            );
        }
    };

    displayTooltip = () => {
        const tooltipContainer = (
            <Tooltip id="flight-finder-tooltip" className="in">
                By providing the flight id, this enables searching for leads that have an approved
                invite in a sent flight.
            </Tooltip>
        );

        return (
            <OverlayTrigger placement="top" overlay={tooltipContainer}>
                <i className="fa fa-question-circle" />
            </OverlayTrigger>
        );
    };

    render() {
        const spinner = this.displayTransmittingSpinner();
        const flightInput = this.displayToggleInput();
        const brandCampaignSelect = this.displayBrandCampaignSelect();
        const tooltip = this.displayTooltip();

        return (
            <div id="find-flight-input">
                <div>
                    Has Approved Invite for Sent Flight {tooltip} {spinner}
                    {flightInput}
                    {brandCampaignSelect}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/flight_finder.js